import {
  currentSubscriptionDaysLeftSelector,
  currentSubscriptionNextRenewalDateSelector,
} from '../../modules/Dashboard';
import { addTopUpToSelection, clearTopUp, initTopUp, topUp } from '../../modules/TopUps/actions';

import { connect } from 'react-redux';
import config from '../../config';
import { balanceSelector } from '../../modules/Customer/selectors';
import { isLoadingSelector } from '../../modules/LoadingStatus';
import { selectedTopUpsPriceSelector, selectedTopUpsSelector } from '../../modules/TopUps';
import { voucherCurrentVoucherDetailsSelector, voucherFilteredAvailableVouchersSelector } from '../../modules/Voucher';
import { setCurrentVoucherDetails } from '../../modules/Voucher/actions';
import TopUp from './TopUp';

const mapStateToProps = state => ({
  daysLeft: currentSubscriptionDaysLeftSelector(state),
  isLoading: isLoadingSelector(state, 'fetchTopUps'),
  nextRenewalDate: currentSubscriptionNextRenewalDateSelector(state),
  price: selectedTopUpsPriceSelector(state),
  selectedTopUps: selectedTopUpsSelector(state),
  walletBalance: balanceSelector(state),
  isConfirmationLoading: isLoadingSelector(state, 'topUpConfirmation'),
  currentVoucherDetails: voucherCurrentVoucherDetailsSelector(state),
  displayVouchersForTopup: config.displayVouchersForTopup,
  filteredAvailableVouchers: voucherFilteredAvailableVouchersSelector(state),
});

const mapDispatchToProps = {
  addTopUpToSelection,
  topUp,
  initTopUp,
  clearTopUp,
  setCurrentVoucherDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopUp);
